import React from 'react';

// StatusLabel component displays a label based on the current application step
const stepLabels = [
  "Submitted",
      "Screening",
      "Interview",
      "Position Filled",
      "offered",
];

const StatusLabel = ({ currentStep }) => {
  // If currentStep is out of bounds, show a default message
  const label = stepLabels[currentStep] || 'Status Unknown';
  return (
    <div className="status-label">
      <span>{label}</span>
    </div>
  );
};

export default StatusLabel;
